// extracted by mini-css-extract-plugin
module.exports = {"tableContainer":"styles_tableContainer__1_zla","table":"styles_table__3zJTM"};